import { useEffect } from 'react';

export const useDocumentTitle = (title?: string) => {
  useEffect(() => {
    const prefix = 'Blockem App';
    const text = title ? `${prefix} | ${title}` : prefix;
    document.title = text;
  }, [title]);
};
